export const htmlReferenceLinks = [
  {
    title: 'Html Editor - animation',
    url: 'https://editor.p5js.org/ ',
  },
];
export const cssReferenceLinks = [
  {
    title: 'CSS',
    url: 'https://blog.bitsrc.io/tagged/css',
  },
];
export const javascriptReferenceLinks = [
  {
    title: 'Algorithms in JavaScript',
    url: 'https://medium.com/siliconwat/algorithms-in-javascript-b0bed68f4038',
  },
  {
    title: 'The Modern JavaScript Tutorial',
    url: 'https://javascript.info/',
  },
  {
    title: 'JavaScript: Best Practice ',
    url:
      'https://www.sitepoint.com/premium/books/javascript-best-practice/read/1',
  },
  {
    title: 'regular esxpression test',
    url: 'https://regexr.com/',
  },
  {
    title: 'extract number from a string javascript',
    url:
      'https://www.codegrepper.com/code-examples/delphi/extract+number+from+a+string+javascript',
  },
  {
    title: 'Babel is a JavaScript compiler.',
    url: 'https://babeljs.io/',
  },

  {
    title: 'Up and Running with ESLint — the Pluggable JavaScript Linter',
    url:
      'https://www.sitepoint.com/up-and-running-with-eslint-the-pluggable-javascript-linter/',
  },
  {
    title: 'Understanding ES6 Modules',
    url: 'https://www.sitepoint.com/understanding-es6-modules/',
  },
  {
    title: 'Learn ES2015',
    url: 'https://babeljs.io/docs/en/learn/',
  },
  {
    title:
      'Static analysis in JavaScript: 11 tools to help you catch errors before users do',
    url:
      'https://blog.logrocket.com/static-analysis-in-javascript-11-tools-to-help-you-catch-errors-before-users-do/',
  },

  {
    title: 'Understanding JavaScript Modules: Bundling & Transpiling',
    url: 'https://www.sitepoint.com/javascript-modules-bundling-transpiling/',
  },
  {
    title: 'Demystifying JavaScript Closures, Callbacks and IIFEs',
    url:
      'https://www.sitepoint.com/demystifying-javascript-closures-callbacks-iifes/',
  },

  {
    title: 'JavaScript Guide',
    url: 'https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide',
  },
  {
    title: 'Learn & Solve : call(), apply() and bind() methods in JavaScript',
    url:
      'https://www.codingame.com/playgrounds/9799/learn-solve-call-apply-and-bind-methods-in-javascript',
  },

  {
    title: 'Understanding Call, Bind and Apply Methods in JavaScript',
    url:
      'https://blog.bitsrc.io/understanding-call-bind-and-apply-methods-in-javascript-33dbf3217be',
  },
];
export const javaReferenceLinks = [];
export const angularReferenceLinks = [
  {
    title:
      'Angular 8 Admin Dashboard Panel from scratch using Angular Material, highcharts and flex-layout ',
    url: 'https://www.youtube.com/watch?v=FP7Hs8lTy1k',
  },
];
export const reactReferenceLinks = [
  {
    title: 'React Router',
    url: 'https://reactrouter.com/web/guides/quick-start',
  },
  {
    title: 'Creating a movie list application - React Projects',
    url:
      'https://subscription.packtpub.com/book/web_development/9781789954937/1/ch01lvl1sec04/creating-a-movie-list-application',
  },
  {
    title: 'ReactJS - Router ',
    url: 'https://www.tutorialspoint.com/reactjs/reactjs_router.htm',
  },
  {
    title: 'Building an Awesome Todo List App in React',
    url: 'https://www.kirupa.com/react/simple_todo_app_react.htm',
  },
  {
    title: 'Building an Awesome Todo List App in React -code',
    url: 'https://github.com/kirupa/kirupa/tree/master/reactjs',
  },
  {
    title: 'Getting started with React Router',
    url: 'https://codeburst.io/getting-started-with-react-router-5c978f70df91',
  },
  {
    title: 'A Simple React Router v4 Tutorial',
    url: 'https://blog.pshrmn.com/simple-react-router-v4-tutorial/',
  },

  {
    title: 'React Redux Tutorials - 2 - Getting Started',
    url:
      'https://www.youtube.com/watch?v=0eluxklOZVo&list=PLC3y8-rFHvwheJHvseC3I0HuYI2f46oAK&index=2',
  },
  {
    title: 'React fundamentals code',
    url: 'https://github.com/gopinav/React-Tutorials',
  },
  {
    title: 'redux-Example: Todo List',
    url: 'https://redux.js.org/basics/example',
  },
  {
    title: 'A Simple React Router v4 Tutorial',
    url:
      'https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf',
  },
  {
    title: 'Checkers game & AI Opponent in react',
    url: 'https://reactjsexample.com/checkers-game-ai-opponent-in-react/',
  },
  {
    title: 'What are Higher-Order Components in React?',
    url: 'https://css-tricks.com/what-are-higher-order-components-in-react/',
  },
  {
    title: "A Quick Intro to React's Higher-Order Components",
    url:
      'https://www.digitalocean.com/community/tutorials/react-higher-order-components',
  },
  {
    title: 'Mastering-React-Test-Driven-Development - code',
    url:
      'https://github.com/PacktPublishing/Mastering-React-Test-Driven-Development',
  },
  {
    title: 'Test-Driven Development with React and Redux, using Redux TDD',
    url:
      'https://medium.com/free-code-camp/test-driven-development-with-react-and-redux-using-redux-tdd-3fd3be299918',
  },
  {
    title: 'TypeScript-React-Starter -code',
    url: 'https://github.com/Microsoft/TypeScript-React-Starter',
  },
  {
    title: 'React Higher-Order Components in TypeScript made simple',
    url:
      'https://dev.to/danhomola/react-higher-order-components-in-typescript-made-simple',
  },
  {
    title: 'React+TypeScript Cheatsheets',
    url:
      'https://github.com/typescript-cheatsheets/react-typescript-cheatsheet#reacttypescript-cheatsheets',
  },
  {
    title: 'Simple Games Built With React.js',
    url:
      'https://medium.com/@samerbuna/simple-games-built-with-react-e13206a76722',
  },
  {
    title: 'Getting Started with Redux',
    url: 'https://redux.js.org/introduction/getting-started',
  },
  {
    title: 'react-jwt-authentication-example',
    url: 'https://github.com/cornflourblue/react-jwt-authentication-example ',
  },
  {
    url:
      'https://jasonwatmore.com/post/2019/04/06/react-jwt-authentication-tutorial-example',
    title: 'React (without Redux) - JWT Authentication Tutorial & Example',
  },
  {
    title: 'JWTs in React for Secure Authentication',
    url: 'https://developer.okta.com/blog/2019/10/02/jwt-react-auth',
  },
  {
    title: 'How to Implement Authentication in ReactJS Using JWT',
    url:
      'https://www.alibabacloud.com/blog/how-to-implement-authentication-in-reactjs-using-jwt_595820',
  },
  {
    title: 'Using JWT in Your React+Redux App for Authorization',
    url:
      'https://levelup.gitconnected.com/using-jwt-in-your-react-redux-app-for-authorization-d31be51a50d2',
  },
  {
    title: 'Secure Your React and Redux App with JWT Authentication',
    url:
      'https://auth0.com/blog/secure-your-react-and-redux-app-with-jwt-authentication/',
  },
  {
    title: 'Building Basic React Authentication',
    url:
      'https://medium.com/better-programming/building-basic-react-authentication-e20a574d5e71',
  },
  {
    title: 'Flow Type Cheat Sheet',
    url:
      'https://www.saltycrane.com/cheat-sheets/flow-type/latest/#lib/react.js',
  },
  {
    title: 'React Native Directory',
    url: 'https://reactnative.directory/',
  },
  {
    title: 'React Native docs',
    url: 'https://reactnative.dev/docs/textinput',
  },
  {
    title: 'Simple Frontend Pagination | React',
    url: 'https://www.youtube.com/watch?v=IYCa1F-OWmk',
  },
];
export const graphqlReferenceLinks = [
  {
    title: 'graphql -Getting Started',
    url: 'https://www.howtographql.com/react-apollo/1-getting-started/',
  },
  {
    title: 'GraphQL & React tutorial (part 1/6)',
    url:
      'https://blog.hichroma.com/graphql-react-tutorial-part-1-6-d0691af25858',
  },
  {
    title: 'React + Apollo Tutorial - Introduction',
    url: 'https://www.howtographql.com/react-apollo/0-introduction/',
  },
  {
    title: 'Get Started Building GraphQL APIs With Node',
    url: 'https://css-tricks.com/get-started-building-graphql-apis-with-node/',
  },

  {
    title: 'Tutorial: How to build a GraphQL server',
    url:
      'https://www.apollographql.com/blog/tutorial-building-a-graphql-server-cddaa023c035/',
  },
  {
    title: 'Graphql',
    url:
      'https://www.newline.co/courses/tinyhouse-react-masterclass/lesson_0.3-how-to-go-through-the-course',
  },
  {
    title: 'Building a GraphQL API with Node and MongoDB',
    url:
      'https://levelup.gitconnected.com/building-your-graphql-api-with-node-and-mongodb-799a2b9ae0b4',
  },
  {
    title:
      'How To Build a GraphQL Server in Node.js Using GraphQL-yoga and MongoDB    ',
    url:
      'https://www.digitalocean.com/community/tutorials/how-to-build-a-graphql-server-in-node-js-using-graphql-yoga-and-mongodb',
  },
  {
    title: 'Developing A GraphQL API With Node.js And MongoDB    ',
    url:
      'https://www.thepolyglotdeveloper.com/2019/02/developing-graphql-api-nodejs-mongodb/',
  },
  {
    title: 'using-graphql-with-mongodb',
    url: 'https://www.compose.com/articles/using-graphql-with-mongodb/',
  },
  {
    title: 'A Simple CRUD App Using GraphQL, NodeJS, and MongoDB    ',
    url:
      'https://medium.com/better-programming/a-simple-crud-app-using-graphql-nodejs-mongodb-78319908f563',
  },
  {
    title:
      'Build a Simple App with GraphQL, NodeJS, Express, and MongoDB - Part 4',
    url:
      'https://kb.objectrocket.com/mongo-db/build-a-simple-app-with-graphql-nodejs-express-and-mongodb-part-4-407',
  },
  {
    title:
      'Build a Simple App with GraphQL, NodeJS, Express, React, and MongoDB - Part 1    ',
    url:
      'https://kb.objectrocket.com/mongo-db/build-a-simple-app-with-graphql-nodejs-express-react-and-mongodb-part-1-400',
  },
  {
    title: 'GraphQL + Mongodb. The easy way.',
    url: 'https://dev.to/alvarojsnish/graphql-mongodb-the-easy-way-ngc',
  },
];
export const nodejsReferenceLinks = [
  {
    title: 'NVM windows',
    url: 'https://github.com/coreybutler/nvm-windows/releases',
  },
  {
    title: 'Node.js Rest APIs example with Express, Sequelize & MySQL',
    url: 'https://bezkoder.com/node-js-express-sequelize-mysql/',
  },
  {
    title: 'How to Create and Publish Your First Node.js Module',
    url:
      'https://codeburst.io/how-to-create-and-publish-your-first-node-js-module-444e7585b738',
  },
  {
    title:
      'Complete REST API with MongoDB Atlas cloud, Node, and Express in 10 minutes',
    url:
      'https://dev.to/lennythedev/rest-api-with-mongodb-atlas-cloud-node-and-express-in-10-minutes-2ii1',
  },
  {
    title: 'Building a RESTful API with Node.js and MongoDB Atlas',
    url:
      'https://blog.yudiz.com/building-a-restful-api-with-node-js-and-mongodb-atlas/',
  },
  {
    title: 'How to Make Discount coupon codes in NodeJs & MongoDb',
    url:
      'https://medium.com/pouya-jabbarisani/make-a-discount-coupon-code-in-nodejs-mongodb-ac1ac5d7c588',
  },
  {
    title:
      'Hide API Keys with a Node.js API Proxy + Caching, Rate Limiting and Slow Downs    ',
    url: 'https://www.youtube.com/watch?v=nCWE6eonL7k',
  },
  {
    title: 'Build your own npm module',
    url: 'https://dev.to/therealdanvega/creating-your-first-npm-package-2ehf',
  },
  {
    title: 'Building Email Verification System Using Node and Redis',
    url:
      'https://codeforgeek.com/node-js-redis-tutorial-building-email-verification-system/',
  },
  {
    title: 'send email using nodejs',
    url: 'https://codeforgeek.com/send-e-mail-node-js/',
  },
  {
    title: 'node-js-redis installation',
    url:
      'https://codeforgeek.com/node-js-redis-tutorial-installation-commands/',
  },
];
export const redisLinks = [
  {
    title: 'redis',
    url: 'https://try.redis.io/',
  },
  {
    title: 'Redis in Action',
    url:
      'https://redislabs.com/ebook/appendix-a/a-3-installing-on-windows/a-3-2-installing-redis-on-window/',
  },
  {
    title: 'node-js-redis installation',
    url:
      'https://codeforgeek.com/node-js-redis-tutorial-installation-commands/',
  },
  {
    title: 'Redis for windows download',
    url: 'https://github.com/dmajkic/redis/downloads',
  },
];
export const booksLinks = [
  {
    title: 'Redis in Action',
    url:
      'https://redislabs.com/ebook/appendix-a/a-3-installing-on-windows/a-3-2-installing-redis-on-window/',
  },
];
export const webpagedesignReferenceLinks = [
  {
    title: 'Wireframing tools',
    url:
      'https://uxplanet.org/5-free-quick-wireframe-tools-for-ui-ux-designers-in-2017-189e6a594fda',
  },
  {
    title: 'Evolus pencil',
    url: 'https://www.youtube.com/watch?v=Ui2Go471ldU',
  },
];
export const mobileAppsReferenceLinks = [
  {
    title: 'Ionic 4 & Angular Tutorial For Beginners - Crash Course',
    url: 'https://www.youtube.com/watch?v=r2ga-iXS5i4',
  },
  {
    title: 'Ionic 5 and Angular 8: Create a Welcome Page with Tabs Home Pages.',
    url:
      'https://www.9lessons.info/2019/08/ionic-5-angular-8-welcome-page.html',
  },
  {
    title: 'Ionic-angular example',
    url: 'https://github.com/srinivastamada/new-ionic-angular',
  },
  {
    title: 'Ionic Installation',
    url: 'https://www.tutorialsplane.com/ionic-installation/',
  },
  {
    title: 'ionic-team/photo-gallery-capacitor-ng - code',
    url:
      'https://github.com/ionic-team/photo-gallery-capacitor-ng/commit/58234117663f006b4dc093f0fe90613a98b0ea1c',
  },
  {
    title: 'Deploying to iOS and Android',
    url:
      'https://ionicframework.com/docs/angular/your-first-app/6-deploying-mobile',
  },
  {
    title:
      'Adding JWT Authentication to an Ionic Application with MongoDB and NestJS',
    url:
      'https://www.joshmorony.com/adding-jwt-authentication-to-an-ionic-application-with-mongodb-and-nestjs/',
  },
];
export const awsReferenceLinks = [
  {
    title: 'nodemailer-and-amazon-ses',
    url:
      'https://stackoverflow.com/questions/23982299/nodemailer-and-amazon-ses',
  },
  {
    title: 'Sending Emails using Amazon SES in Node.js',
    url: 'https://attacomsian.com/blog/amazon-ses-integration-nodejs/',
  },
  {
    title:
      '[CHALLENGE] Build and deploy (with DNS / SSL) a URL Shortener in 3133.7 seconds (52 minutes)    ',
    url: 'https://www.youtube.com/watch?v=gq5yubc1u18',
  },
  {
    title: 'Using AWS S3 Buckets in a NodeJS App    ',
    url:
      'https://medium.com/codebase/using-aws-s3-buckets-in-a-nodejs-app-74da2fc547a6',
  },
  {
    title: 'Deploying a React App with AWS S3    ',
    url: 'https://www.youtube.com/watch?v=rVj3zc30-8E',
  },
  {
    title: 'Deploying a react app to AWS    ',
    url: 'https://www.youtube.com/watch?v=xT2OhBTjZDY',
  },
  {
    title: 'Static site deployment: Github to S3',
    url:
      'https://medium.com/@michal.frystacky/static-site-github-to-s3-770953a90f67',
  },
];
export const chatAppReferenceLinks = [
  {
    title: 'webrtc-from-chat',
    url: 'https://github.com/mdn/samples-server/tree/master/s/webrtc-from-chat',
  },
  {
    title: 'WebRTC - Voice Demo',
    url: 'https://www.tutorialspoint.com/webrtc/webrtc_voice_demo.htm',
  },
];
export const dsandAlgReferenceLinks = [];
export const vuejsReferenceLinks = [
  {
    title: 'Vue.js: Understanding its Tools and Ecosystem',
    url:
      'https://subscription.packtpub.com/book/business_and_other/9781800206625',
  },
  {
    title: 'Vue Tutorial: An Overview and Walkthrough',
    url: 'https://www.taniarascia.com/getting-started-with-vue/',
  },
];
export const devopsandCICDReferenceLinks = [
  {
    title: 'CI/CD Notes: Nest.JS + Travis CI + Docker',
    url:
      'https://medium.com/@shantanoodesai/ci-cd-notes-nest-js-travis-ci-docker-75843ab2287e',
  },
  {
    title: 'Continuously deploy Node apps with GitHub, Travis and Heroku',
    url:
      'https://shapeshed.com/continuously-deploy-node-apps-with-github-travis-and-heroku/',
  },
  {
    title: 'travis yml example',
    url:
      'https://github.com/shantanoo-desai/nestjs-products-api/blob/master/.travis.yml',
  },
  {
    title: 'Setup NestJs Server on Heroku',
    url:
      'https://medium.com/@terence410/setup-nestjs-server-on-heroku-1475c5cdb1d1',
  },
  {
    title: 'Continuous deployment of a Nest.js application to Heroku',
    url: 'https://circleci.com/blog/continuous-deployment-nestjs/',
  },
  {
    title: 'DevOps Automation with MongoDB Atlas',
    url: 'https://scotch.io/bar-talk/devops-automation-with-mongodb-atlas',
  },
  {
    title:
      'Deploy(Travis/Gitlab CI) Frontend APPs on AWS S3 and distributing with AWS CloudFront    ',
    url:
      'https://codeburst.io/deploy-travis-gitlab-ci-frontend-apps-on-aws-s3-and-distributing-with-aws-cloudfront-5acbe4699057',
  },
  {
    title: 'Continuous Integration with Angular and Travis CI    ',
    url: 'https://www.youtube.com/watch?v=ojr2Dy0Pjhw',
  },
];
export const animationReferenceLinks = [
  {
    title: 'Web Animations API',
    url: 'https://developer.mozilla.org/en-US/docs/Web/API/Web_Animations_API',
  },
  {
    title: 'animaker',
    url: 'https://app.animaker.com/pricing',
  },
  {
    title: 'Top 10 Whiteboard Animation Software Free 2020    ',
    url:
      'https://www.essencestudios.net/blog/top-10-whiteboard-animation-software',
  },
  {
    title: 'moovly',
    url: 'https://www.moovly.com/pricing',
  },
];
export const webAppSecurityReferenceLinks = [
  {
    title: 'Passport strategies',
    url:
      'https://subscription.packtpub.com/book/web_development/9781788831147/6/ch06lvl1sec46/passport-js-strategies',
  },
  {
    title: 'NodeJS security cheat sheet',
    url:
      'https://cheatsheetseries.owasp.org/cheatsheets/Nodejs_Security_Cheat_Sheet.html',
  },
  {
    title:
      'Adding JWT Authentication to an Ionic Application with MongoDB and NestJS',
    url:
      'https://www.joshmorony.com/adding-jwt-authentication-to-an-ionic-application-with-mongodb-and-nestjs/',
  },
];

export const nestjsReferenceLinks = [
  {
    title: 'Nest.js Tutorial: JWT Authentication with Passport.js',
    url: 'https://www.techiediaries.com/nestjs-tutorial-jwt-authentication/',
  },
  {
    title: 'Building a modern app using Nest.js, MongoDB and Vue.js',
    url:
      'https://scotch.io/tutorials/building-a-modern-app-using-nestjs-mongodb-and-vuejs',
  },
  {
    title: 'Nest.js Step-by-Step: Part 3 (Users and Authentication)',
    url:
      'https://www.codemag.com/Article/2001081/Nest.js-Step-by-Step-Part-3-Users-and-Authentication',
  },
  {
    title: 'nestjs-mongodb-jwt-auth - code',
    url: 'https://github.com/joshuamorony/nestjs-mongodb-jwt-auth',
  },
  {
    title: 'Using MongoDB with Ionic and NestJS',
    url: 'https://www.joshmorony.com/using-mongodb-with-ionic-and-nestjs/',
  },
  {
    title:
      'Adding JWT Authentication to an Ionic Application with MongoDB and NestJS',
    url:
      'https://www.joshmorony.com/adding-jwt-authentication-to-an-ionic-application-with-mongodb-and-nestjs/',
  },
];

export const interviewQuestionReferenceLinks = [
  {
    title: 'javascript-code-interview-questions',
    url: 'https://www.fullstack.cafe/blog/javascript-code-interview-questions',
  },
  {
    title: 'React online test',
    url: 'https://app.testdome.com/t?generatorId=104',
  },
  {
    title: 'AlgoExpert-Ace the technical interviews',
    url: 'https://www.algoexpert.io/product',
  },
];

export const typescriptReferenceLinks = [
  {
    title: 'TypeScript Basics',
    url:
      'https://subscription.packtpub.com/book/web_development/9781789610253/app01/app01lvl1sec115/chapter-1-typescript-basics',
  },
];

export const unOrganizedLinks = [
  {
    title: 'An Introduction to Gulp.js',
    url: 'https://www.sitepoint.com/introduction-gulp-js/',
  },

  {
    title: 'Basic Maps with D3.js',
    url: 'https://investingdeeply.com/blog/basic-maps-with-d3/',
  },
  {
    title: 'D3 Workshop Series-Mapping Data with D3',
    url: 'http://duspviz.mit.edu/d3-workshop/mapping-data-with-d3/',
  },

  {
    title: 'Code Tidbits',
    url: 'https://www.samanthaming.com/tidbits/',
  },

  {
    title: 'Coding Garden videos',
    url: 'https://coding.garden/videos/#/?filter=',
  },

  {
    title: 'Apache Kafka - Re-engineered for the Cloud',
    url:
      'https://www.confluent.io/confluent-cloud/marketplace/?utm_medium=display&utm_source=google&utm_campaign=ch.display_tp.prs_tgt.keyword-inmarket_rgn.apac_lng.eng_dv.all_con.confluent-cloud&utm_term=&creative=cc-akms-insd&device=c&placement=www.youtube.com&gclid=EAIaIQobChMIlZH7p7-L6wIVBJqPCh1MKATgEAEYASAAEgJK1_D_BwE',
  },

  {
    title: 'AWS - Set up new CloudFront Distribution with S3 bucket - DEMO    ',
    url: 'https://www.youtube.com/watch?v=hEdYnN8dnRs&t=484s',
  },
  {
    url:
      'https://www.w3schools.com/howto/tryit.asp?filename=tryhow_css_social_media_buttons',
    title: 'Style Social Media Buttons - example code',
  },
  {
    title: 'ImageBase for websites',
    url: 'https://childdevelop.org/credit-cards-horitontal1/',
  },
];

const imageDecriptionTemplate = {
  image: '',
  name: '',
  description: '',
};

export const karnatakaTravelImageLinks = [
  {
    url: 'assets/my-travel/murudeshwar.jpg',
    name: 'Murudeshwar',
    description: '',
  },
];
export const keralaTravelImageLinks = [
  {
    url: 'assets/my-travel/wayanad.jpg',
    name: 'Wayanad',
    description: '',
  },
];

export const andhraTravelImageLinks = [
  {
    url: 'assets/my-travel/Ahobilam.jpg',
    name: 'Ahobilam',
    description: '',
  },
];

export const tamilnaduTravelImageLinks = [
  {
    url: 'assets/my-travel/Hogenakkal.jpg',
    name: 'Hogenakkal',
    description: '',
  },
];
